import { StatusChip } from '@/design';

/**
 * "Under review" — the participant holds a work item survey-api counts as under review
 * (`WorkItemStates.UnderReview`: `pending_firm` or `escalated`), as every screen that names a
 * participant draws it (SR-222, F9's R11): the person hub's header and each household member's
 * card, every row of `ResponsesTable` (the responses list and the hub's Surveys), and each
 * participant of a People row.
 *
 * **Drawn as sent, never derived.** The flag is survey-api's `underReview`, decided there over the
 * item states; this side counts no items and reads no state to arrive at it — a second evaluator of
 * a rule the queue already applies. Absent (an API from before SR-222's block 10) draws nothing,
 * and so does `false`: neither is said as "not under review", which only the server could know.
 *
 * In the `attention` tone, the disclosure summary's while something is live: it asks for a look,
 * and is not the verdict `danger` would be. `data-under-review` is what a spec reads.
 */
export function UnderReviewChip({ underReview }: { underReview: boolean | undefined }) {
  if (underReview !== true) return null;
  return (
    <span data-under-review="" className="inline-flex">
      <StatusChip tone="attention">Under review</StatusChip>
    </span>
  );
}
